module.exports = __webpack_public_path__ + "img/3.2ecc1057.png";